import { ProductOutboundTransactionDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { errorObjectToString } from 'src/utils/common';
import { QueryOptions, WHERE } from 'src/utils/firebase/firebase-manager';
import { getCollectionCount, observeProductOutboundTransaction } from 'src/utils/firebase/firebase-short-cut';

const MAX_TRANSACTIONS = 5000; // 최대 허용 트랜잭션 수
const getQueries = (inventoryId: string | null, startValue: string, endValue: string) => {
  const wheres: WHERE[] = [['inventoryId', '==', inventoryId]];
  const options: QueryOptions = {
    sortKey: 'requestDate',
    orderBy: 'desc',
    startValue,
    endValue,
  };
  return { wheres, options };
};
const checkCount = async (wheres: WHERE[], options: QueryOptions) => {
  const countSnapshot = await getCollectionCount('productOutboundTransaction', wheres, options);
  const count = countSnapshot.data().count;
  if (count > MAX_TRANSACTIONS) {
    return {
      isValid: false,
      errorMessage: `데이터가 너무 많습니다 (${count}건 / 최대 ${MAX_TRANSACTIONS}건). 날짜 범위를 좁혀서 다시 시도해주세요.`,
    };
  }
  return {
    isValid: true,
    errorMessage: null,
  };
};

const useOutboundTxnsForInventory = (inventoryId: string | null, startValue: string, endValue: string) => {
  const [loading, setLoading] = useState(false);
  const [outboundTransactions, setOutboundTransactions] = useState<ProductOutboundTransactionDoc[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const initializeSubscription = async () => {
      const queries = getQueries(inventoryId, startValue, endValue);
      try {
        const isValidCount = await checkCount(queries.wheres, queries.options);
        if (isValidCount.errorMessage) {
          throw new Error(isValidCount.errorMessage);
        }
      } catch (error) {
        const errorMessage = errorObjectToString(error);
        setError(errorMessage);
        setLoading(false);
        return;
      }

      const outboundTransaction$ = observeProductOutboundTransaction(queries.wheres, queries.options);
      const subscription = outboundTransaction$.subscribe((outboundTransactions) => {
        setOutboundTransactions(outboundTransactions);
        setLoading(false);
      });
      return subscription;
    };

    let subscription: any;
    initializeSubscription().then((sub) => {
      subscription = sub;
    });

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [inventoryId, startValue, endValue]);

  return { outboundTransactions, loading, error };
};

export default useOutboundTxnsForInventory;
